import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import { FaGift } from "react-icons/fa"; // 🎁 Import gift icon from React Icons

// ✅ Keyframes for subtle bounce effect
const bounce = keyframes`
  0% { transform: translateY(-10px); }
  50% { transform: translateY(10px); }
  100% { transform: translateY(-10px); }
`;

// ✅ Styled Components
const StyledContainer = styled.div`
  background-color: black;
  color: white;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
`;

const AnimatedGift = styled(FaGift)`
  font-size: 80px;
  color: yellow;
  animation: ${bounce} 1.2s ease-in-out infinite alternate;
`;

const StyledText = styled.h2`
  font-size: 24px;
  font-weight: bold;
  color: white;
  margin-bottom: 10px;
`;

const RewardBox = styled.div`
  font-size: 24px;
  padding: 10px;
  border: 2px solid orange;
  border-radius: 8px;
  color: white;
  margin-bottom: 20px;
`;

const AnimatedRevealText = styled.p`
  font-size: 24px;
  color: white;
  text-shadow: 0 0 5px green;
  margin-bottom: 20px;
`;

const ClaimButton = styled.button`
  background-color: #ff7c24;
  color: white;
  font-size: 20px;
  font-weight: bold;
  padding: 12px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  width: 80%;
  max-width: 300px;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: #e66a1a;
  }
`;

const UnlockGift = ({ onContinue }) => {
  const [reveal, setReveal] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setReveal(true);
    }, 500);
  }, []);

  return (
    <StyledContainer>
      {/* ✅ Animated Gift Icon */}
      <AnimatedGift />

      {/* ✅ Gift Message */}
      <StyledText>You have unlocked a gift</StyledText>

      {/* ✅ Reward Box */}
      <RewardBox>One-time streak freeze</RewardBox>

      {/* ✅ Animated Reveal Text */}
      {reveal && (
        <AnimatedRevealText>
          You can miss a day of practice without losing your streak.
        </AnimatedRevealText>
      )}

      {/* ✅ Claim Button */}
      <ClaimButton onClick={onContinue}>Claim it</ClaimButton>
    </StyledContainer>
  );
};

export default UnlockGift;

